<template>
    <div class="fLink">
        <dl>
            <dt>{{panel.title}}</dt>
            <dd>
                <link-item v-for="(link, index) in panel.children" :key="index" :item="link"></link-item>
            </dd>
        </dl>
    </div>
</template>
<script>
    import LinkItem from './LinkItem'
    export default {
        name: 'LinkPanel',
        props: ['panel'],
        components: {
            LinkItem
        }
    }
</script>
